<template>
    <div id="app">
        <app-header></app-header>
        <app-body></app-body>

        <!-- Full screen loading icon -->
        <hec-loading :full="true"></hec-loading>

        <!-- General error messaging -->
        <hec-toast></hec-toast>
    </div>
</template>

<script>
import AppHeader from "./components/AppHeader";
import AppBody from "./components/AppBody";
import HecLoading from "./components/global/HecLoading";
import HecToast from "./components/global/HecToast";

export default {
    name: "App",
    components: {
        AppHeader,
        AppBody,
        HecLoading,
        HecToast
    },
    mounted() {
        this.$root.$emit("loadingStart", "Loading Contributors");
    }
};
</script>

<style lang="scss">
@media screen {
    #app {
        display: flex;
        flex-direction: column;
        position: absolute;
        @include fill-space;
        z-index: 0;

        @include media-breakpoint-up(lg) {
            overflow: hidden;
        }
    }
}
</style>
